var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolicitarExames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8335 18.0933C7.8335 18.952 7.9835 19.7616 8.2585 20.5467H7.8335C3.696 20.5467 0.333496 17.2469 0.333496 13.1867C0.333496 8.28 7.8335 0 7.8335 0C7.8335 0 13.221 5.94933 14.8585 10.7333C10.9585 11.0032 7.8335 14.1925 7.8335 18.0933ZM16.5835 16.8667V13.1867H14.0835V16.8667H10.3335V19.32H14.0835V23H16.5835V19.32H20.3335V16.8667H16.5835Z",
    fill: "#C6120E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitarExames);
export default __webpack_public_path__ + "static/media/solicitar_exames.f91a4f86071daabd0ef299e40eb0ae94.svg";
export { ForwardRef as ReactComponent };